import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteServices() {
  const site = useSiteContent();
  usePageMeta("Event Medical Services | First Aid & Medical Cover for Events | WEMS",
    "Tailored medical cover for events of all sizes — medical event cover and sports event medical cover, from first responders to doctors, across Wales and the whole UK.", "", "services");
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-services">
      <SiteHeader />
      <SiteSections sections={site.page_sections.services} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
